import { render, staticRenderFns } from "./TextMatchCheckpoint.vue?vue&type=template&id=0d2a4be1&scoped=true&"
import script from "./TextMatchCheckpoint.vue?vue&type=script&lang=js&"
export * from "./TextMatchCheckpoint.vue?vue&type=script&lang=js&"
import style0 from "./TextMatchCheckpoint.vue?vue&type=style&index=0&id=0d2a4be1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2a4be1",
  null
  
)

export default component.exports